import { initializeApp } from 'firebase/app'
import { getToken, onMessage, getMessaging, deleteToken } from 'firebase/messaging'
import { checkExistServiceWorker } from './serviceWorker'
import { FIREBASE, TEXT_ENCRYPT, getLocalStorage, getSessionStorage } from '../helpers'
import { ACCOUNT } from '../reduxs'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

export const firebaseApp = initializeApp(firebaseConfig)
export const messaging = getMessaging(firebaseApp)

export const requestPermission = async () => {
  return await Notification.requestPermission()
}

export const getMessagingToken = async (permission, serviceWorkerRegistration) => {
  if (permission === FIREBASE.PERMISSION.GRANTED) {
    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY
    const messageToken = await getToken(messaging, { vapidKey, serviceWorkerRegistration })
    
    return messageToken
  } else if (permission === FIREBASE.PERMISSION.DENIED) {
    // TODO : adding message when permission denied or do something
  }
}

export const registerFirebase = async (serviceWorkerRegistration) => {
  try {
    const permission = await requestPermission()
    const messageToken = await getMessagingToken(permission, serviceWorkerRegistration)

    return messageToken
  } catch {
    console.error('registerFirebase error')
  }
}

export const revokeToken = async () => {
  try{
    await deleteToken(messaging)
  }catch{
    console.error('revokeToken error')
  }

}

export const initFirebase = async () => {
  if (getSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN) || getLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)) {
    const { allServiceWorkers } = await checkExistServiceWorker()

    if (allServiceWorkers) {
      const [FirebaseServiceWorker] = allServiceWorkers
      
      const fcmToken = await registerFirebase(FirebaseServiceWorker)
      const device = FIREBASE.DEVICE.BOOKING
      const params = {
        fcmToken,
        device,
      }
      
      return ACCOUNT.action.registerFCMtoken(params)
    }
  }
}

export const onMessageListener = (setNotificationData = () => {}, openAndCloseToast = () => {}) => {
  onMessage(messaging, (payload) => {
    setNotificationData(payload)
    openAndCloseToast()
  })
}
